// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1151y","label":"styles_label__BF4QD"};